(() => {
  function parseBoolean(value) {
    if (value === "true") return true;
    if (value === "false") return false;
    return null;
  }

  function ensureLuxCallsToAction(scope = document) {
    const heroActions = scope.querySelector?.(".lux-hero__actions");
    if (heroActions && !heroActions.querySelector("a")) {
      const primary = document.createElement("a");
      primary.className = "button";
      primary.href = "/sale";
      primary.textContent = "Start a label order";

      const secondary = document.createElement("a");
      secondary.className = "button button--secondary";
      secondary.href = "/pages/quote-request";
      secondary.textContent = "Get a fast quote";

      heroActions.append(primary, secondary);
    }

    const policies = scope.querySelector?.(".lux-policies");
    if (policies && !policies.querySelector(".lux-cta a")) {
      const wrapper = policies.querySelector(".page-width") || policies;
      const cta = document.createElement("div");
      cta.className = "lux-cta";

      const link = document.createElement("a");
      link.className = "button";
      link.href = "/pages/policies";
      link.textContent = "View all policies";

      cta.append(link);
      wrapper.append(cta);
    }
  }

  function initGlide(root) {
    if (!root || root.dataset.luxGlideInit === "1") return;
    if (typeof window.Glide !== "function") return;

    const prefersReducedMotion = window.matchMedia?.(
      "(prefers-reduced-motion: reduce)"
    )?.matches;

    const autoplayEnabled = parseBoolean(root.dataset.autoplay) ?? false;
    const autoplayMs = Number(root.dataset.autoplayMs || "6000");
    const gap = Number(root.dataset.gap || "16");
    const animationDuration = Number(root.dataset.animationDuration || "450");

    const options = {
      type: "carousel",
      perView: 1,
      gap: Number.isFinite(gap) ? gap : 16,
      animationDuration: Number.isFinite(animationDuration)
        ? animationDuration
        : 450,
      autoplay:
        prefersReducedMotion || !autoplayEnabled || !Number.isFinite(autoplayMs)
          ? false
          : autoplayMs,
      hoverpause: true,
    };

    const glide = new window.Glide(root, options);
    glide.mount();
    root.dataset.luxGlideInit = "1";
  }

  function initAll(scope = document) {
    ensureLuxCallsToAction(scope);
    const nodes = scope.querySelectorAll?.(".lux-glide.glide");
    if (!nodes || !nodes.length) return;
    nodes.forEach(initGlide);
  }

  document.addEventListener("DOMContentLoaded", () => initAll());
  document.addEventListener("shopify:section:load", (event) => {
    if (event?.target) initAll(event.target);
  });
})();
